import { TranslationObject } from '../i18n/translation';

const namespace = 'psaRoles';

const translations: TranslationObject = {
  veileder: {
    id: `${namespace}.veileder`,
    nb: 'Veileder',
    en: 'Supervisor',
  },
  koordinator: {
    id: `${namespace}.koordinator`,
    nb: 'Koordinator',
    en: 'Coordinator',
  },
};

export default translations;
